/* eslint-disable max-len */

import $ from 'jquery';

let isLightDismissibleInitialized = false;

/*
  Light Dismissible controller can help the element to be light dismissed when clicked else where.
  Give the target grid class name of "light-dismissible" and importing this function should do the job.

  Currently, it works element that can be toggled with either "hide" or "show" class.

  NOTE: If the element that toggles the visibility is outside of the target light dismissible element,
  clicked the toggle button will invoke this function to dismiss the target.

  For this, give e.originalEvent.noDismiss to the target class name.
*/
export default () => {
  if (!isLightDismissibleInitialized) {
    $(window).click((e) => {
      const $lightDismissibles = $('.light-dismissible');

      if ($lightDismissibles.length === 0) {
        return;
      }

      const clickedEl = $(e.target);

      $lightDismissibles.each((index) => {
        if (clickedEl.closest($lightDismissibles[index]).length === 0) {
          if (e.originalEvent && e.originalEvent.noDismiss) {
            if ($($lightDismissibles[index]).hasClass(e.originalEvent.noDismiss)) {
              return;
            }
          }

          if (!$($lightDismissibles[index]).hasClass('hide')) {
            $($lightDismissibles[index]).addClass('hide');
          }

          if ($($lightDismissibles[index]).hasClass('show')) {
            $($lightDismissibles[index]).removeClass('show');
          }
        }
      });
    });

    isLightDismissibleInitialized = true;
  }
};
